import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonBackButton,
} from "@ionic/react";

import { arrowBackOutline } from "ionicons/icons";

import React, { ReactNode, useContext, Fragment } from "react";

import { AppContext } from "../../base/AppContext";
import { AlertRequestFail } from "../../components/Alert";

import "./Page.css";

interface PageProps {
  name: string;
  children: ReactNode;
  back?: string | boolean;
  ionToolBar?: ReactNode;
}

const Page: React.FC<PageProps> = ({ name, children, ionToolBar, back }) => {
  const { error, loading } = useContext(AppContext);
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            {back ? (
              <Fragment>
                <IonBackButton
                  style={{ color: "#fff" }}
                  icon={arrowBackOutline}
                />
                {/* <Link to={back}>
                  <IonButton style={{ color: "#fff" }}>
                    <IonIcon icon={arrowBackOutline} />
                  </IonButton>
                </Link> */}
              </Fragment>
            ) : (
              <IonMenuButton />
            )}
          </IonButtons>
          <IonTitle>{name}</IonTitle>
          {ionToolBar}
        </IonToolbar>
      </IonHeader>

      <IonContent className="background-content">
        {error && !loading ? <AlertRequestFail /> : null}
        {children}
      </IonContent>
    </IonPage>
  );
};

export default Page;
